import styled from 'styled-components'
import { Fade } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { SuccessCircle } from 'assets/images'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { ClientRoute } from 'routes/client'

interface Props {
  close: () => void
}

export default function CourseVersionSaveSuccessDialog({ close }: Props): JSX.Element {
  const intl = useIntl()

  return (
    <Fade in unmountOnExit>
      <Background>
        <Container>
          <TopBar>
            <Close onClick={close} />
          </TopBar>

          <Content>
            <Image src={SuccessCircle} />
            <Title>{intl.formatMessage({ id: 'courseEditor.dataSavedDialogTitle' })}</Title>
            <Text>{intl.formatMessage({ id: 'courseEditor.dataSavedDialogText' })}</Text>
            <ButtonsContainer>
              <HomeLink to={ClientRoute.COURSE_EDITOR_FRONT_PAGE}>
                <HomePage>{intl.formatMessage({ id: 'strings.homepage' })}</HomePage>
              </HomeLink>
              <Continue onClick={close}>{intl.formatMessage({ id: 'strings.continue' })}</Continue>
            </ButtonsContainer>
          </Content>
        </Container>
      </Background>
    </Fade>
  )
}

const Background = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${(props) =>
    props.theme.palette.type === 'light' ? 'rgba(255,255,255,0.8)' : 'rgba(68,68,68,0.8)'};
  z-index: 10000;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  box-shadow: 0px 14px 24px 0px #0000001a;
  border-radius: 8px;
  width: 750px;
  height: 70%;
`

const TopBar = styled.div`
  height: 44px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  gap: 20px;
  padding: 0 150px 20px;
`

const Title = styled.h2`
  font-size: 22px;
  font-weight: 700;
  line-height: 26px;
  color: #032615;
`

const Text = styled.p`
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  color: #032615;
  padding-bottom: 20px;
`

const Close = styled(CloseIcon)`
  float: right;
  padding: 10px;
  font-weight: 700;
  cursor: pointer;
`

const Image = styled.img`
  width: 150px;
  height: 150px;
  margin: auto;
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 53px;
  gap: 20px;
  padding-bottom: 20px;
`

const BaseButton = styled.button`
  height: 100%;
  background-color: transparent;
  border: 2px solid;
  border-color: ${(props) => props.theme.palette.primary.main};
  border-radius: 8px;
  color: ${(props) => props.theme.palette.primary.main};
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  text-align: center;
  cursor: pointer;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`
const HomeLink = styled(Link)`
  width: 50%;
`
const HomePage = styled(BaseButton)`
  background-color: ${(props) => props.theme.palette.primary.main};
  color: #fff;
  width: 100%;
`
const Continue = styled(BaseButton)`
  width: 50%;
`
